<script setup lang="ts">
import {requiredIf, email, helpers} from "@vuelidate/validators";
import {computed, watchEffect,} from "vue";
import useVuelidate, { type ValidationRule} from "@vuelidate/core";
import {AsYouType} from "libphonenumber-js";
import {intl} from '../utilities/translations'

const props = defineProps({
  model: {
    type: null,
    required: true,
  },
  type: {
    type: String,
    default: "text",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  messages: {
    type: Object,
    default: () => ({}),
  },
  lazy: {
    type: Boolean,
    default: true,
  },
});


const rules = computed(() => {
  if (props.disabled)
    return {};
  const localRules: { model: Record<string, ValidationRule> } = {
    model: {
      required: helpers.withMessage(
          props.messages.required ?? intl.formatMessage({id: "To pole jest wymagane"}),
          requiredIf(() => !!props.required)
      ),
    },
  };
  switch (props.type) {
    case 'email':
      localRules.model.email = helpers.withMessage(
          props.messages.email ?? intl.formatMessage({id: "Niepoprawny adres email"}),
          email,
      );
      break;
    case 'phone':
      localRules.model.phone = helpers.withMessage(
          props.messages.phone ?? intl.formatMessage({id: "Niepoprawny numer telefonu"}),
          (v: string) => {
            const asYouType = new AsYouType();
            asYouType.input(v);
            return asYouType.isValid();
          },
      );
  }
  return localRules;
});

const v$ = useVuelidate(
    rules,
    {
      model: computed(() => props.model)
    },
    {
      $autoDirty: true,
      $lazy: props.lazy,
      $scope: 'form',
    }
);

const isValid = computed(() => {
  return v$.value.$dirty ? !v$.value.$invalid : true;
});

const errors = computed(() => isValid.value ? [] : v$.value.$errors.map(e => e.$message));

const error = computed(() => errors.value[0] ?? '');

watchEffect(() => {
  if (props.lazy && v$.value.$dirty && !props.model) {
    v$.value.$reset();
  }
});

</script>
<template>
  <div style="display: inline-flex; flex-flow: column nowrap;">
    <slot :is-valid="isValid"/>
    <slot name="error"
          :is-valid="isValid"
          :errors="errors"
          :error="error">
      <span class="nf-input-wrapper__error">{{ error }}</span>
    </slot>
  </div>
</template>
